import { useMemo } from "react"

let id = 1

export const uniqueId = () => ++id

export function useUniqueId() {
    return useMemo(() => `uid-${++id}`, [])
}
